import getOperator from './getOperator'
import login from './login'
import externalLogin from './externalLogin'
import { activate, signup } from './signup'
import { check, checkToken } from './check'
import logout from './logout'
import { resetPassword, newPassword } from './resetPassword'
import { tokenRefresh } from "./tokenRefresh"
import settings from "./settings"

export default {
  login,
  activate,
  signup,
  check,
  checkToken,
  getOperator,
  logout,
  resetPassword,
  newPassword,
  externalLogin,
  tokenRefresh,
  settings,
}
